/* http post method | khaled Mofeed  */
export const HTTP_POST_METHOD = "post";
/* http get method | khaled Mofeed  */
export const HTTP_GET_METHOD = "get";
/* http get method | khaled Mofeed  */
export const HTTP_DELETE_METHOD = "delete";
